var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCryptocurrency(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 48,
    viewBox: "0 0 512 512",
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flat"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 255.426,
    cy: 240.574,
    fill: "#ffc864",
    r: 48.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 120h464v40h-464z",
    fill: "#b5cf7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m472 120h-432v-40l216-56 216 56z",
    fill: "#b5cf7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72 120v-16l184-48 184 48v16z",
    fill: "#9cb26d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40 192h64v232h-64z",
    fill: "#b5cf7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408 192h64v232h-64z",
    fill: "#b5cf7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72 272a8 8 0 0 1 -8-8v-72a8 8 0 0 1 16 0v72a8 8 0 0 1 -8 8z",
    fill: "#9cb26d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72 424a8 8 0 0 1 -8-8v-120a8 8 0 0 1 16 0v120a8 8 0 0 1 -8 8z",
    fill: "#9cb26d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440 272a8 8 0 0 1 -8-8v-72a8 8 0 0 1 16 0v72a8 8 0 0 1 -8 8z",
    fill: "#9cb26d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440 432a8 8 0 0 1 -8-8v-128a8 8 0 0 1 16 0v128a8 8 0 0 1 -8 8z",
    fill: "#9cb26d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 160h80v32h-80z",
    fill: "#b5cf7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 424h80v32h-80z",
    fill: "#b5cf7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 440h80v16h-80z",
    fill: "#9cb26d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400 160h80v32h-80z",
    fill: "#b5cf7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400 424h80v32h-80z",
    fill: "#b5cf7f"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#9cb26d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m40 192h64v13.453h-64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40 410.274h64v13.453h-64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408 192h64v13.453h-64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408 410.274h64v13.453h-64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400 440h80v16h-80z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 160h80v16h-80z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400 160h80v16h-80z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m24 456h464v32h-464z",
    fill: "#b5cf7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.425 296.824a56.25 56.25 0 1 1 56.25-56.25 56.313 56.313 0 0 1 -56.25 56.25zm0-96.5a40.25 40.25 0 1 0 40.25 40.25 40.295 40.295 0 0 0 -40.25-40.25z",
    fill: "#ecab2c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m272 250.039v-18.419l-15.951-9.21-15.952 9.21v18.419l15.952 9.209z",
    fill: "#ecab2c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m366.306 274.077a8 8 0 0 0 -6.306-3.077h-32a8 8 0 0 0 0 16h6.7l-69.589 45.554-19.944-19.062a8 8 0 0 0 -9.874-.932l-87.641 56.724a8 8 0 1 0 8.694 13.432l82.335-53.29 19.969 19.084a8 8 0 0 0 9.909.91l78.423-51.337-2.744 10.977a8 8 0 1 0 15.522 3.88l8-32a8 8 0 0 0 -1.454-6.863z",
    fill: "#92d1f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152 424h48v32h-48z",
    fill: "#d78e0c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m232 384h48v72h-48z",
    fill: "#ecab2c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m312 344h48v112h-48z",
    fill: "#ffc864"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptocurrency);
export default __webpack_public_path__ + "static/media/cryptocurrency.d5a6ebd3a1f8e107444a61bba6449a6c.svg";
export { ForwardRef as ReactComponent };